import { createRedirectOrderDrawerRequestStore } from '../utils/createRedirectOrderDrawerRequestStore.util';

export const REDIRECT_ORDER_DRAWER_REQUEST_STORE = createRedirectOrderDrawerRequestStore();
